import { palette } from '@livable/saas-react-components';
export const stripeStyles = {
  labels: 'floating',
  variables: {
    fontFamily: '"Source Sans Pro",sans-serif',
    borderRadius: '2px',
    colorPrimary: palette.primary.main,
    colorDanger: palette.error.main,
    colorText: palette.shades[800],
    colorSuccess: palette.success.main,
    colorWarning: palette.warning.main,
    colorIconTab: palette.shades[700],
    colorTextPlaceholder: palette.shades[700],
    colorPrimaryText: 'red'
  },
  rules: {
    '.AccordionItem': {
      boxShadow: 'none',
      borderColor: palette.shades[300]
    },
    '.TabIcon': {
      fill: palette.shades[700]
    },
    '.TabIcon--selected': {
      fill: palette.primary.main
    },
    '.Input': {
      padding: '8px 12px',
      boxShadow: 'none'
    }
  }
};